// The `getField()` and `updateField()`
// helper functions, are needed to update
// the mapped fields in a Vuex conform manner.
import { getField } from 'vuex-map-fields'

// Initial state
// state object.
// each Vuex instance is just a single state tree.
const state = {
  result: null
}

// getters
const getters = {
  getField
}

// actions
const actions = {
  async setRequestData ({ commit }, result) {
    commit('UPDATE_REQUEST_STATUS', result)
  },
  clean ({ commit }) {
    commit('CLEAN')
  }
}

// mutations
// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  UPDATE_REQUEST_STATUS (state, payload) {
    state.result = payload
  },
  CLEAN (state) {
    state.result = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
